import React, {useMemo} from 'react';
import {Layout} from '..';
import {TooltipArrowProps} from './types';
import {getArrowspacingWidth} from './functions/getArrowspacingWidth';
import {getArrowspacingHeight} from './functions/getArrowspacingHeight';

export const TooltipArrow: React.FC<TooltipArrowProps> = ({
  tooltipWidth,
  tooltipHeight,
  arrowPosition,
}) => {
  const arrowType = useMemo(() => {
    if (arrowPosition.startsWith('Top')) {
      return (
        <Layout
          height={0}
          width={0}
          borderLeftStyle="solid"
          borderLeftColor="transparent"
          borderLeftWidth="6"
          borderRightStyle="solid"
          borderRightColor="transparent"
          borderRightWidth="6"
          borderBottomColor="background_mono_inverse_primary"
          borderBottomStyle="solid"
          borderBottomWidth="6"></Layout>
      );
    } else if (arrowPosition.startsWith('Bottom')) {
      return (
        <Layout
          height={0}
          width={0}
          borderLeftStyle="solid"
          borderLeftColor="transparent"
          borderLeftWidth="6"
          borderRightStyle="solid"
          borderRightColor="transparent"
          borderRightWidth="6"
          borderTopColor="background_mono_inverse_primary"
          borderTopStyle="solid"
          borderTopWidth="6"></Layout>
      );
    } else if (arrowPosition.startsWith('Left')) {
      return (
        <Layout
          height={0}
          width={0}
          borderRightStyle="solid"
          borderRightColor="background_mono_inverse_primary"
          borderRightWidth="6"
          borderTopStyle="solid"
          borderTopColor="transparent"
          borderTopWidth="6"
          borderBottomColor="transparent"
          borderBottomStyle="solid"
          borderBottomWidth="6"></Layout>
      );
    } else {
      return (
        <Layout
          height={0}
          width={0}
          borderLeftStyle="solid"
          borderLeftColor="background_mono_inverse_primary"
          borderLeftWidth="6"
          borderTopStyle="solid"
          borderTopColor="transparent"
          borderTopWidth="6"
          borderBottomColor="transparent"
          borderBottomStyle="solid"
          borderBottomWidth="6"></Layout>
      );
    }
  }, [arrowPosition]);

  return (
    <>
      <Layout
        width={getArrowspacingWidth(arrowPosition, tooltipWidth)}
        height={getArrowspacingHeight(arrowPosition, tooltipHeight)}
      />
      {arrowType}
    </>
  );
};
